import { track } from '@upms/analytics';
import { POLICY_EVENTS, type PaymentMethodCategory, type PaymentProvider } from './events';
import type { ErrorCategory } from './errorCategory';

export type PaymentMethodUpdateOutcome = {
  provider: PaymentProvider;
  methodCategory: PaymentMethodCategory;
  /** The last failure seen in this dialog, or `none` if there was none. */
  errorCategory: ErrorCategory;
};

/**
 * Fires exactly one of Completed / Failed / Abandoned for the payment-method
 * dialog's close — the same mutually-exclusive, self-describing pattern as
 * the COI events. Pulled out of PaymentDialogShell's handleClose so the
 * outcome-selection logic is unit-testable without rendering the dialog.
 */
export const trackPaymentMethodUpdateOutcome = (
  didSucceed: boolean,
  { provider, methodCategory, errorCategory }: PaymentMethodUpdateOutcome
): void => {
  if (didSucceed) {
    track(POLICY_EVENTS.paymentMethodUpdateCompleted, {
      provider,
      method_category: methodCategory,
    });
    return;
  }

  if (errorCategory === 'none') {
    track(POLICY_EVENTS.paymentMethodUpdateAbandoned, {
      provider,
      method_category: methodCategory,
    });
    return;
  }

  track(POLICY_EVENTS.paymentMethodUpdateFailed, {
    error_category: errorCategory,
    provider,
    method_category: methodCategory,
  });
};
